/* ========================= NPM ======================== */
// jQuery
import "./base/_jquery-global";

// Popper.js (* tooltip, popover, dropdown)
// import * as Popper from "@popperjs/core";

// Bootstrap modules
import "bootstrap/js/dist/modal";
import "bootstrap/js/dist/carousel";
import "bootstrap/js/dist/collapse";

// AOS
import AOS from "aos";
AOS.init({
    disable: "tablet",
    disable: "phone",
});

/* ======================== BASE ======================== */
// Import utilities as needed
import {
    utl_setFooterYear,
    utl_ehElements,
    utl_anchorScrollOffset,
    // utl_toggleCookiesAlert,
} from "./base/_utils";

// Call utility functions after imported
utl_setFooterYear();
utl_anchorScrollOffset();
// utl_toggleCookiesAlert();

document.querySelector(".eh-container") && utl_ehElements();
document.querySelector('.carousel[data-sa-slide="auto"]') && utl_toggleCarouselPausePlayBtn();

/* ===================== COMPONENTS ===================== */
import navigationInit from "./components/_navigation";
navigationInit();

/* ======================== PAGES ======================= */
// Individual page scripts are added in the header of specific page's index file
